import { uniqBy } from 'lodash';

class FilterObject {
  constructor(filter) {
    this.title = filter.title;
    this.include_enabled = filter.include_enabled === undefined ? true : filter.include_enabled;
    this.exclude_enabled = filter.exclude_enabled === undefined ? true : filter.exclude_enabled;
    this.group_ids = this.include_enabled ? filter.include_group_ids || [] : [];
    this.skill_ids = this.include_enabled ? filter.include_skill_ids || [] : [];
    this.duty_function_ids = this.include_enabled ? filter.include_duty_function_ids || [] : [];
    this.availability_code_ids = this.include_enabled ? filter.include_availability_code_ids || [] : [];
    this.exclude_group_ids = this.exclude_enabled ? filter.exclude_group_ids || [] : [];
    this.exclude_skill_ids = this.exclude_enabled ? filter.exclude_skill_ids || [] : [];
    this.exclude_duty_function_ids = this.exclude_enabled ? filter.exclude_duty_function_ids || [] : [];
    this.exclude_availability_code_ids = this.exclude_enabled ? filter.exclude_availability_code_ids || [] : [];
    // By default, only available members are shown. Only in the case that an an availability code
    // that is NOT available for crewing, it should turn to false. The following validation
    // defaults filters created before this changes to true
    this.onlyAvailable = filter.onlyAvailable === undefined ? true : filter.onlyAvailable;
    this.minimumCrew = filter.minimumCrew;
  }

  filter(members, options) {
    const filteredMembers = members.filter(m => this.satisfiesConditions(m, options));
    return uniqBy(
      filteredMembers.map(m => m.user),
      'id'
    );
  }

  some(members, options) {
    return members.some(m => this.satisfiesConditions(m, options));
  }

  satisfiesConditions(member) {
    // If only available is true, member must be available
    if (this.onlyAvailable && !member.available) return false;
    return (
      this.hasGroup(member) &&
      this.hasSkills(member) &&
      this.hasDutyFunction(member) &&
      this.hasAvailabilityCode(member)
    );
  }

  satisfiesFilter(possessedIds, includeIds, excludeIds) {
    return (
      // if there is nothing to filter
      (includeIds.length === 0 && excludeIds.length === 0) ||
      // if there are no included ids, or member has an included id
      ((includeIds.length === 0 || possessedIds.some(id => includeIds.includes(id))) &&
        // if there are no excluded ids, or member doesn't have the excluded ids
        (excludeIds.length === 0 || !possessedIds.some(id => excludeIds.includes(id))))
    );
  }

  // Check if there are group filters and if member has any of them
  hasGroup = member => this.satisfiesFilter([member.groupId], this.group_ids, this.exclude_group_ids);

  // Check if there are skill filters and if member has any of them
  hasSkills = member =>
    this.satisfiesFilter(
      member.skills.map(s => s.id),
      this.skill_ids,
      this.exclude_skill_ids
    );

  // Check if there are duty function filters and if member has any of them
  hasDutyFunction = member =>
    this.satisfiesFilter(
      member.assignedFunctions.map(f => f.id),
      this.duty_function_ids,
      this.exclude_duty_function_ids
    );

  // Check if there are availability code filters and if member has any of them
  hasAvailabilityCode = member => {
    const hasCode = member.availabilityCode !== undefined;
    // availability code is a special case: member can have undefined availability code
    if (this.availability_code_ids.length === 0 && !hasCode) return true;
    if (this.availability_code_ids.length > 0 && !hasCode) return false;
    return this.satisfiesFilter(
      [member.availabilityCode.id],
      this.availability_code_ids,
      this.exclude_availability_code_ids
    );
  };
}

export default FilterObject;
